module.exports = __webpack_public_path__ + "img/pr-10.feae7322.png";